export const defaultNodeJSNavigatorContextProvider = () => ({
    referrer: null,
    userAgent: null,
    location: null,
    clientId: '',
});
export const getNavigatorContext = (relay, customProvider) => {
    const { referrer, userAgent, location, clientId } = relay.getMeta('');
    const customContext = customProvider ? customProvider() : {};
    return { ...customContext, referrer, userAgent, location, clientId };
};
